// src/App.js

import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

// Lazy-loaded route components for code splitting
const Home = lazy(() => import('./components/Home'));
const Contact = lazy(() => import('./components/Contact'));
const AboutUs = lazy(() => import('./components/AboutUs'));
const OurServices = lazy(() => import('./components/OurServices'));
const Blogs = lazy(() => import('./components/Blogs'));
const Blog1 = lazy(() => import('./pages/Blog1'));
const Blog2 = lazy(() => import('./pages/Blog2'));
const Blog3 = lazy(() => import('./pages/Blog3'));
const Blog4 = lazy(() => import('./pages/Blog4'));
const SuccessStory = lazy(() => import('./components/Successstory'));
const PrivacyPolicy = lazy(() => import('./components/Privacy'));
const TermsOfService = lazy(() => import('./components/Terms'));

const App = () => {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen text-xl">Loading...</div>}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/our-services" element={<OurServices />} />
        <Route path="/success-story" element={<SuccessStory />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog1" element={<Blog1 />} />
        <Route path="/blog2" element={<Blog2 />} />
        <Route path="/blog3" element={<Blog3 />} />
        <Route path="/blog4" element={<Blog4 />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="*" element={<div className="flex items-center justify-center min-h-screen text-2xl font-bold">404 — Page Not Found</div>} />
      </Routes>
    </Suspense>
  );
};

export default App;